export function ErrorBand({ message, hint }: { message: string; hint?: string }) {
  return (
    <div className="error-band" role="alert">
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <path d="M8 1.5 15 14.5H1Z" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 6v4" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="8" cy="12.2" r="0.9" fill="currentColor" />
      </svg>
      <div>
        <div>{message}</div>
        {hint ? <div className="hint">{hint}</div> : null}
      </div>
    </div>
  );
}
